/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Observability_Title13Inputs */

const en_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluation & monitoring`)
};

const ar_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقييم والمراقبة`)
};

const bn_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইভ্যালুয়েশন ও মনিটরিং`)
};

const de_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswertung & Überwachung`)
};

const es_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluación y seguimiento`)
};

const fr_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluation et suivi`)
};

const pt_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação e monitoramento`)
};

const zh_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评估和监控`)
};

const tr_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değerlendirme ve izleme`)
};

const ru_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка и мониторинг`)
};

const pl_svc_ai_agent_development_observability_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Observability_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena i monitorowanie`)
};

/**
* | output |
* | --- |
* | "Evaluation & monitoring" |
*
* @param {Svc_Ai_Agent_Development_Observability_Title13Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_observability_title13 = /** @type {((inputs?: Svc_Ai_Agent_Development_Observability_Title13Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Observability_Title13Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "de") return de_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "es") return es_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_observability_title13(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_observability_title13(inputs)
	return en_svc_ai_agent_development_observability_title13(inputs)
});
export { svc_ai_agent_development_observability_title13 as "svc_ai-agent-development_OBSERVABILITY_title" }